import { microConfig } from './port-config'
import store from '@/store/index'

/**
 * @param { route } to
 * 路由切换时，对子应用显示状态进行修改
 */
export const guardMicroFunc = (to) => {
  const {path} = to
  const index = microConfig.findIndex(subApp => path.includes(subApp.name))
  index === -1 ? store.commit('SET_SHOWAPP', '') : store.commit('SET_SHOWAPP',{module:  microConfig[index].name})
}

/**
 * @param { route } to
 * 路由切换时，对子应用显示状态进行修改
 */

export const menusHandler = (menus) => {

  menus.forEach(item => {
    let target = microConfig.find(subApp => subApp.moduleid == item.moduleid)
    if(typeof target !== 'undefined') {
      item.module = target.name
    }
    if(item.children && item.children.length > 0) {
      item.children = menusHandler(item.children)
    }

  });

  return menus
}







// WEBPACK FOOTER //
// ./src/micro-app/utils.js